export const IDTYPE = [
  { name: "Philippine Passport" },
  { name: "UMID" },
  { name: "GSIS ID" },
  { name: "Driver's License" },
  { name: "PRC ID" },
  { name: "Voter's ID" },
  { name: "Postal ID" },
  { name: "Senior Citizen ID" },
  { name: "TIN ID" },
  { name: "SSS ID" },
];

export default IDTYPE;
